var _path, _path2, _path3, _path4, _path5;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgBounceCapPressed(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M521.065 19.5001H24.5002V344.674H521.065V19.5001Z",
    fill: "#C22626",
    stroke: "#FF4343"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M182 106.064L225.332 149.415V230.548L182 273.899V106.064Z",
    fill: "#FF4343"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M186.561 100L230.643 144.102H313.385L357.467 100H186.561Z",
    fill: "#FF4343"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M363 105.09L318.696 149.415V230.548L363 274.873V105.09Z",
    fill: "#FF4343"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M187.523 279L230.643 235.861H313.385L356.505 279H187.523Z",
    fill: "#FF4343"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBounceCapPressed);
export default __webpack_public_path__ + "static/media/bounce-cap-pressed.69badd10d0c14cb0aa219ab1dd9a9472.svg";
export { ForwardRef as ReactComponent };